import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";
import { DEBOUNCE } from "../../../../../../../../../utils";
import { YOUTUBE_AUTOCOMPLETE } from "../../../../../../../../../actions/addFeedActions";
import SearchPlace from "../../../../../../Feeds/AddFeeds/Elements/SearchPlace";


class YoutubeFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            textField: "",
            shorts: "",
            playList: "",
            keyword: "",
            location: "",
            locationKeyword: "",
            error: false,
            shortError: false,
            playListError: false,
            keywordError: false,
            locationError: false,
            locationKeywordError: false,
            channelId: "",
            shortId: "",
            playlistId: "",
            latlng: null,
            loading: false,
            errorMsg: null,
            list: [],
            listError: false,
            filterId: props.selectedFilterId
        }
    }

    onTextFieldChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, shortError: false, keywordError: false, playListError: false, locationKeywordError: false, errorMsg: null });

    onLatlanChange = (value) => this.setState({ latlng: value, locationError: false, errorMsg: null });

    onLocationValueChange = (value) => this.setState({ location: value });

    onChannelIdChange = (value, fullPath, tab) => {
        if (tab == 1) {
            this.setState({ channelId: value, textField: fullPath });
        } else if (tab == 75) {
            this.setState({ shortId: value, shorts: fullPath });
        } else if (tab == 11) {
            this.setState({ playlistId: value, playList: fullPath });
        }
    }

    onTextValueChange = (tab, value) => {
        if (tab == 1) {
            this.setState({ textField: value, error: false, errorMsg: null });
        } else if (tab == 75) {
            this.setState({ shorts: value, shortError: false, errorMsg: null });
        } else if (tab == 11) {
            this.setState({ playList: value, playListError: false, errorMsg: null });
        } else if (tab == 4) {
            this.setState({ keyword: value, keywordError: false, errorMsg: null });
        } else if (tab == 32) {
            this.setState({ location: value, locationError: false, latlng: null });
        }
    }

    autoComplete = DEBOUNCE(query => {
        const { selectedFilterId } = this.props;
        const searchYoutube = String(query).length;

        if (searchYoutube && [11, 1, 75].includes(selectedFilterId)) {
            try {
                const type = selectedFilterId == 11 ? "playlist" : "channel";

                YOUTUBE_AUTOCOMPLETE(query, type).then(res => {
                    const { responseCode, listItems } = res.data;
                    if (responseCode == 200) {
                        if (listItems && listItems.length > 0) {
                            this.setState({ list: listItems })
                        } else {
                            this.setState({ list: [], listError: true })
                        }

                    }
                }).catch(err => {
                    this.setState({ list: [], listError: true })
                })
            } catch (error) {
                console.log(error)
            }
        }
        else {
            this.setState({ list: [] });
        }
    })

    onChangeHandler = (e) => {
        this.onTextFieldChange(e);
        this.setState({ listError: false });
        
        if(e.target.value.length == 0){
            this.setState({ list: [], listError: false });
        }
        if (e.target.value && e.target.value.length > 2) {
            this.autoComplete(e.target.value);
        }
    }

    onListClick = (item) => {
        try {
            const { selectedFilterId } = this.props;

            this.setState({ list: [], listError: false }, () => {
                this.onTextValueChange(selectedFilterId, selectedFilterId == "Play List" ? item.snippet.title : item.snippet.channelTitle);
                const fullPath = `https://www.youtube.com/${selectedFilterId == 11 ? "playlist?list=" : "channel/"}${selectedFilterId == 11 ? item.snippet.playlistId : selectedFilterId == 75 ? item.id.channelId.replace("UC", "UUSH") : item.id.channelId}`;
                this.onChannelIdChange(`${selectedFilterId == 11 ? item.snippet.playlistId : selectedFilterId == 75 ? item.id.channelId.replace("UC", "UUSH") : item.id.channelId}`, fullPath, selectedFilterId);
            })
        } catch (error) {
            console.log(error);
        }
    }

    onSubmit = () => {
        const { textField, keyword, shorts, playList, channelId, shortId, playlistId, latlng, location, locationKeyword } = this.state;
        const { updateStep, selectedFilterId } = this.props;

        if (selectedFilterId == 1 && textField == "") {
            this.setState({ error: true, errorMsg: null })
        } else if (selectedFilterId == 75 && shorts == '') {
            this.setState({ shortError: true, errorMsg: null })
        } else if (selectedFilterId == 11 && playList == '') {
            this.setState({ playListError: true, errorMsg: null })
        } else if (selectedFilterId == 4 && keyword == '') {
            this.setState({ keywordError: true, errorMsg: null })
        } else if (selectedFilterId == 32 && location == '') {
            this.setState({ locationError: true, errorMsg: null })
        } else if (selectedFilterId == 32 && latlng == null) {
            this.setState({ locationError: true, errorMsg: "Please select an option" })
        } else if (selectedFilterId == 32 && locationKeyword == '') {
            this.setState({ locationKeywordError: true })
        } else if (selectedFilterId == 1 && !textField.includes("://")) {
            this.setState({ error: true, errorMsg: "Please select an option" });
        } else if (selectedFilterId == 75 && !shorts.includes("://")) {
            this.setState({ shortError: true, errorMsg: "Please select an option" });
        } else if (selectedFilterId == 11 && !playList.includes("://")) {
            this.setState({ playListError: true, errorMsg: "Please enter valid Playlist url" })
        } else if (selectedFilterId == 11 && playlistId == "") {
            this.setState({ playListError: true, errorMsg: "Please select an option" })
        } else {

            var obj = {
                networkId: 7,
                filter: selectedFilterId,
                moderation: 0,
                channelId: "",
            }
            if (selectedFilterId == 1) {
                obj['feedText'] = textField;
                obj['channelId'] = channelId;
            } else if (selectedFilterId == 75) {
                obj['feedText'] = shorts;
                obj['channelId'] = shortId;
            } else if (selectedFilterId == 11) {
                obj['feedText'] = playList;
                obj['channelId'] = playlistId;
            } else if (selectedFilterId == 4) {
                obj['feedText'] = keyword;
            } else if (selectedFilterId == 32) {
                obj['feedText'] = location;
            }
            if (selectedFilterId == 32) obj = { ...obj, keywords: locationKeyword, latlng };

            this.setState({ loading: true, error: false, shortError: false, keywordError: false, playListError: false, keywordError: false, locationError: false, locationKeywordError: false });

            updateStep(2, obj, () => this.setState({ loading: false }));
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.state.filterId != nextProps.selectedFilterId){
            this.setState({ list: [], listError: false, filterId: nextProps.selectedFilterId },()=>this.onTextValueChange(nextProps.selectedFilterId, ''));
        }
    }


    render() {
        const { textField, shorts, playList, keyword, location, locationKeyword, latlng, list, listError, error, shortError, playListError, keywordError, locationError, locationKeywordError, errorMsg, loading } = this.state;
        const { selectedFilterId } = this.props;

        const hideErrorMsg = selectedFilterId == 1 ? error : selectedFilterId == 75 ? shortError : selectedFilterId == 11 ? playListError : true;
        return (
            <div className="ob-feed-form-wrapper w-100">
                {selectedFilterId == 32 ? <div className="selectSource-right"><div className="advance-input">
                    <SearchPlace onFieldTextChange={this.onLocationValueChange} onLatlanChange={this.onLatlanChange} /> 
                    {locationError ? <span id="feedsfield1error" className="errorMessage required">{errorMsg ? errorMsg : 'This field is required'}</span> : null}
                    </div></div>
                    : <div className="selectSource-right mb-3">
                        <div className="position-relative advance-input custom-input">
                            <div className="position-relative d-flex ">
                                <span className="hastag d-flex align-items-center">
                                    <i className={`fas fa-${(selectedFilterId == 75 || selectedFilterId == 1) ? 'at' : selectedFilterId == 11 ? 'list' : selectedFilterId == 4 ? "font" : selectedFilterId == 32 ? "globe" : ""}`}></i>
                                </span>
                                <InputField name={`${selectedFilterId == 1 ? 'textField' : selectedFilterId == 75 ? "shorts" : selectedFilterId == 11 ? "playList" : selectedFilterId == 4 ? "keyword" : ""}`} placeholder={selectedFilterId == 1 ? "Enter channel URL or name here.." : selectedFilterId == 75 ? "Enter shorts URL or handle here.." : selectedFilterId == 11 ? "Enter playlist URL or ID here.." : selectedFilterId == 4 ? "Enter keyword here.." : "Enter channel URL here.."} className="form-control p-3" value={selectedFilterId == 1 ? textField : selectedFilterId == 75 ? shorts : selectedFilterId == 11 ? playList : selectedFilterId == 4 ? keyword : textField} onChangeHandler={(e) => this.onChangeHandler(e)} autoComplete={true} />
                            </div>
                            {list && list.length ? <div className='handlelist dropdown-menu d-block'>
                                <ul className="list-unstyled">
                                    {list.map(item => (
                                        <li data-handle="FdgnlfsSdfgsg" key={item.etag} onClick={() => this.onListClick(item)}>
                                            <div className="d-flex align-items-center">
                                                <div className="img-card">
                                                    <img src={item.snippet.thumbnails.default.url} className="img-fluid" />
                                                </div>
                                                <div className="img-text">
                                                    {`https://www.youtube.com/${selectedFilterId == 4 ? "playlist?list=" : "channel/"}${selectedFilterId == 4 ? item.snippet.playlistId : item.id.channelId}`}<br/>
                                                    <span>{item.snippet.channelTitle}</span>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div> : null}
                            {(listError && !hideErrorMsg && ![32, 4].includes(selectedFilterId)) ? <span id="feedsfield1error" className="errorMessage required">{`Invalid ${selectedFilterId != 11 ? 'channel name' : 'playlist id'}`}</span> : null}
                            {(error && selectedFilterId == 1) ? <span id="feedsfield1error" className="errorMessage required">{errorMsg ? errorMsg : 'This field is required'}</span> : null}
                            {(shortError && selectedFilterId == 75) ? <span id="feedsfield1error" className="errorMessage required">{errorMsg ? errorMsg : 'This field is required'}</span> : null}
                            {(playListError && selectedFilterId == 11) ? <span id="feedsfield1error" className="errorMessage required">{errorMsg ? errorMsg : 'This field is required'}</span> : null}
                            {(keywordError && selectedFilterId == 4) ? <span id="feedsfield1error" className="errorMessage required">{errorMsg ? errorMsg : 'This field is required'}</span> : null}
                        </div>
                    </div>}
                {selectedFilterId == 32 ? <div className="selectSource-right mb-3">
                    <div className="form-group position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-at`}></i>
                            </span>
                            <InputField name={"locationKeyword"} placeholder="Enter location keyword here.." className="form-control p-3" value={locationKeyword} onChangeHandler={(e) => this.onTextFieldChange(e)} />
                        </div>
                        {locationKeywordError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                    </div>
                </div> : null}
                <div className="click-next d-flex align-items-center justify-content-between py-3 px-3 rounded">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 1 ? !textField.trim() : selectedFilterId == 75 ? !shorts.trim() : selectedFilterId == 11 ? !playList.trim() : selectedFilterId == 4 ? !keyword.trim() : selectedFilterId == 32 ? (!location.trim() || !locationKeyword.trim() || latlng == null) : false} />
                </div>
            </div>
        )
    }
}

export default YoutubeFeed;